/**
 * Searchspring → Typesense URL Migration
 *
 * Catches old Searchspring deep-link hash URLs and redirects them
 * to the equivalent Typesense query-parameter format.
 *
 * Old format: /collections/napa#/filter:ss_type:Lighting
 * New format: /collections/napa?tag_type=Lighting
 *
 * Old format: /search?q=...#/filter:ss_brand:Galerie/filter:ss_type:Fabric
 * New format: /search?q=...&tag_brand=Galerie&tag_type=Fabric
 *
 * This runs once on page load and performs a client-side redirect.
 * It can be removed after a transition period (e.g., 6–12 months).
 */
(function () {
  'use strict';

  var hash = window.location.hash;
  // Match either an ss filter or an ss sort fragment.
  if (!hash || (hash.indexOf('#/filter:ss_') === -1 && hash.indexOf('#/sort:ss_') === -1)) return;

  // Map Searchspring facet names to Typesense field names. Keep this in
  // sync with FACET_MAP in typesense-search/scripts/rewrite_searchspring_urls.py.
  var fieldMap = {
    'ss_type': 'tag_type',
    'ss_brand': 'tag_brand',
    'ss_color': 'tag_color',
    'ss_pattern': 'tag_pattern',
    'ss_style': 'tag_style',
    'ss_category': 'tag_category',
    'ss_room': 'tag_room',
    'ss_subtype': 'tag_subtype',
    'ss_shape': 'tag_shape',
    'ss_size': 'tag_size',
    'ss_sale': 'tag_group'
  };

  // Per-facet value overrides. Mirrors FACET_VALUE_MAP in the rewriter.
  var fieldValueMap = {
    'ss_sale': { 'Yes': 'Sale Eligible' }
  };

  // Sort: ss_days_since_published:asc → newest first. Mirrors SORT_MAP in
  // the rewriter and the items defined for the sortBy widget.
  var sortMap = {
    'ss_days_since_published:asc': 'products/sort/published_at:desc',
    'ss_days_since_published:desc': 'products/sort/published_at:asc'
  };

  // Parse the Searchspring hash fragment.
  // Format: #/filter:ss_type:Lighting/filter:ss_brand:Galerie/sort:ss_x:asc
  var parts = hash.replace('#/', '').split('/');
  var params = new URLSearchParams(window.location.search);

  // Use the configured collection name when available so the sort value
  // matches the items wired in typesense-search.js.
  var cfg = window.__TYPESENSE_PREDICTIVE_CONFIG || window.__TYPESENSE_CONFIG || {};
  var collectionName = cfg.collectionName || 'products';

  var changed = false;

  parts.forEach(function (part) {
    // Sort: sort:ss_days_since_published:asc
    if (part.indexOf('sort:') === 0) {
      var sortKey = part.slice(5);
      var mapped = sortMap[sortKey];
      if (mapped) {
        params.set('sort', collectionName + mapped.replace(/^products/, ''));
        changed = true;
      }
      return;
    }

    var match = part.match(/^filter:([^:]+):(.+)$/);
    if (!match) return;

    var ssField = match[1];
    var rawValue = match[2];

    // Drop unknown ss_ fields rather than guessing — guessing previously
    // turned `ss_anything` into `tag_anything`, which created phantom
    // refinements that filtered out every result.
    if (!fieldMap.hasOwnProperty(ssField)) return;
    var tsField = fieldMap[ssField];
    if (!tsField) return;

    // Decode double-encoded values (e.g., $2520 → %20 → space)
    var value = rawValue
      .replace(/\$25/g, '%')        // $2520 → %20
      .replace(/\$253E/gi, '>');     // $253E → >

    try {
      value = decodeURIComponent(value);
    } catch (e) {
      // Use as-is if decoding fails
    }

    var overrides = fieldValueMap[ssField];
    if (overrides) {
      if (!overrides.hasOwnProperty(rawValue)) return;
      value = overrides[rawValue];
    } else if (ssField === 'ss_type' && value.indexOf('>') !== -1) {
      // Split hierarchical "Parent>Child" into tag_type + tag_subtype.
      var split = value.split('>');
      var parent = split[0].trim();
      var child = split.slice(1).join('>').trim();
      if (parent) appendParam(params, 'tag_type', parent);
      if (child) appendParam(params, 'tag_subtype', child);
      changed = true;
      return;
    }

    appendParam(params, tsField, value);
    changed = true;
  });

  function appendParam(params, key, value) {
    var existing = params.get(key);
    if (existing) {
      // Avoid duplicate values when the same refinement appears twice.
      var seen = existing.split('~');
      if (seen.indexOf(value) === -1) {
        params.set(key, existing + '~' + value);
      }
    } else {
      params.set(key, value);
    }
  }

  if (changed) {
    var newUrl = window.location.pathname + '?' + params.toString();
    window.location.replace(newUrl);
  }
})();
